import NavbarDesktop from '@components/common/navbar/NavbarDesktop';
import NavbarTablet from '@components/common/navbar/NavbarTablet';
import { Wrapper, Spacer } from './Header.styles';

export default function Header() {
  return (
    <>
      <Wrapper>
        <NavbarDesktop />
        <NavbarTablet />
      </Wrapper>
      <Spacer />
    </>
  );
}
